
export const setSearchResultsTabSelect = (tabNumber) => ({
    type: 'SetSearchResultsTabSelect',
    payload: tabNumber
})
